// Costs exist only in this panel - the permissions are the ones the
// CostViewSet checks.
export const costPermissionsConst = {
  view: {
    value: "view_cost",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu kosztów stałych!",
  },
  add: {
    value: "add_cost",
    errorMsg: "Użytkownik nie ma uprawnień do dodania kosztów stałych!",
  },
  update: {
    value: "change_cost",
    errorMsg: "Użytkownik nie ma uprawnień do edycji kosztów stałych!",
  },
  delete: {
    value: "delete_cost",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania kosztów stałych!",
  },
};
